import { onBeforeUnmount, onMounted, type Ref } from 'vue'

// Fires `onOutside` when a mousedown lands outside the element bound to
// `elementRef`. Used by popovers / dropdowns that need to dismiss when the
// user clicks elsewhere. `mousedown` (not `click`) so the dismiss happens
// before the new target receives focus — matches the popover-toggle UX in
// orders + wallets transaction lists.
export function useClickOutside(elementRef: Ref<HTMLElement | null>, onOutside: () => void): void {
  const handleMousedown = (event: MouseEvent) => {
    const element = elementRef.value
    if (!element) return
    if (!element.contains(event.target as Node)) onOutside()
  }

  onMounted(() => {
    document.addEventListener('mousedown', handleMousedown)
  })

  onBeforeUnmount(() => {
    document.removeEventListener('mousedown', handleMousedown)
  })
}
